import React from 'react';
import { StyledIconButton } from '../../styles/matieralui/IconButton';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { StyledButton } from '../../styles/matieralui/Button';
import { IconAdd } from '../../capturecollab/Icons';

export const NewContentButton = (props) => {

    if (props?.buttonText) return (
        <StyledButton  {...props} variant="contained" color="blue">{props.buttonText}</StyledButton>
    )

    return (
        <StyledIconButton {...props}><IconAdd /></StyledIconButton>
    )
}